// Intersection Observer for Reveal animations
// Intersection Observer for Reveal animations
document.addEventListener('DOMContentLoaded', () => {
    // Check for Shopify Design Mode
    const isDesignMode = (window.Shopify && window.Shopify.designMode);

    const revealElements = document.querySelectorAll('.reveal-up, .image-reveal-wrapper');

    if (isDesignMode) {
        // Immediately show all elements in editor
        revealElements.forEach(el => el.classList.add('visible'));
    } else {
        // Normal animation logic
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        revealElements.forEach(el => observer.observe(el));
    }
});

// Handle Shopify Theme Editor events for re-rendered sections
document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    // Force visibility on all reveal elements within the reloaded section
    const elements = container.querySelectorAll('.reveal-up, .image-reveal-wrapper');
    elements.forEach(el => el.classList.add('visible'));
});

// Since we removed the navbar from this section (it's part of the theme header now),
// we might not need the navbar scroll effect script here if the theme handles it.
// However, if the user wants to keep the specific behavior for this LP, we would need to target the theme's header.
// For now, I will comment it out as requested "remove header and footer".
/*
window.addEventListener('scroll', () => {
    const navbar = document.getElementById('navbar');
    if (navbar) {
        if (window.scrollY > 50) {
            navbar.classList.add('shadow-sm');
            navbar.classList.add('bg-white/95');
            navbar.classList.remove('bg-white/80');
            navbar.classList.replace('py-5', 'py-3');
        } else {
            navbar.classList.remove('shadow-sm');
            navbar.classList.remove('bg-white/95');
            navbar.classList.add('bg-white/80');
            navbar.classList.replace('py-3', 'py-5');
        }
    }
});
*/

// Particle System
const canvas = document.getElementById('particles-canvas');
if (canvas) {
    const ctx = canvas.getContext('2d');

    let width, height;
    let particles = [];

    function resize() {
        width = canvas.width = window.innerWidth;
        height = canvas.height = window.innerHeight;
    }

    class Particle {
        constructor() {
            this.x = Math.random() * width;
            this.y = Math.random() * height;
            this.vx = (Math.random() - 0.5) * 0.2;
            this.vy = (Math.random() - 0.5) * 0.2;
            this.size = Math.random() * 2;
            this.alpha = Math.random() * 0.5;
        }

        update() {
            this.x += this.vx;
            this.y += this.vy;

            if (this.x < 0) this.x = width;
            if (this.x > width) this.x = 0;
            if (this.y < 0) this.y = height;
            if (this.y > height) this.y = 0;
        }

        draw() {
            ctx.fillStyle = `rgba(197, 160, 89, ${this.alpha})`; // Gold color
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fill();
        }
    }

    function initParticles() {
        particles = [];
        for (let i = 0; i < 50; i++) {
            particles.push(new Particle());
        }
    }

    function animateParticles() {
        ctx.clearRect(0, 0, width, height);
        particles.forEach(p => {
            p.update();
            p.draw();
        });
        requestAnimationFrame(animateParticles);
    }

    window.addEventListener('resize', () => {
        resize();
        initParticles();
    });

    resize();
    initParticles();
    animateParticles();
}